import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { CustomizeOrderModel } from "../models/CustomizeOrderModel";
import { ConfigClass } from "./../config";

@Injectable({
  providedIn: "root"
})
export class CustomizeOrdersService {
  // Base url
  baseurl = ConfigClass.getEndpoint;

  // get token fromm storage
  token = JSON.parse(sessionStorage.getItem("currentUser"));

  // Http Headers
  httpOptions: any = {
    headers: new HttpHeaders({}),
  };

  constructor(private http: HttpClient) {
    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Content-Type",
      "application/json"
    );
  }

  // GET
  GetAllOrders(filters): Observable<any> {
    var query = "";
    if (filters.paid === true || filters.paid === false) {
      query += "&paid=" + filters.paid;
    }
    return this.http
      .get<CustomizeOrderModel>(
        this.baseurl +
        "/customizedServices/all?page=" +
        filters.page +
        "&size=" +
        filters.size +
        "&fromDate=" +
        filters.fromDate +
        "&toDate=" +
        filters.toDate +
        "&ownerName=" +
        filters.ownerName +
        "&unitNumber=" +
        filters.unitNumber +
        // "&projectId=" +
        filters.projectId +
        // "&serviceTypeId=" +
        filters.serviceId +
        "&status=" +
        filters.status + query,
        this.httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }


  // PUT
  assignSurveyTechnical(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/assignSurvey",
        dataObj,
        this.httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }

  // POST
  addOrderItems(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/addItems",
        dataObj,
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  // PUT
  CompleteOrder(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/complete",
        dataObj,
        this.httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }

  //PUT
  RollBackOrder(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/rollback",
        dataObj,
        this.httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }

  confirmSurveyOrder(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/confirmSurvey",
        dataObj,
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  //PUT
  confirmAssignOrder(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/confirmAssign",
        dataObj,
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }
  //PUT
  confirmCompleteOrder(dataObj) {
    return this.http
      .put<CustomizeOrderModel>(
        this.baseurl + "/customizedServices/confirmComplete",
        dataObj,
        this.httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }

  deleteOrder(id) {
    return this.http
      .put<any>(
        this.baseurl + "/customizedServices/" + id + "/delete",
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  getImage(path) {

    let httpOptions: any = {
      headers: new HttpHeaders({}),
    };

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Content-Type",
      "application/json"
    );

    httpOptions.responseType = "arraybuffer";

    return this.http
      .get<any>(
        this.baseurl +
        "/images/getImage?imagePath=" + path,
        httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }

  // PUT
  updateOrderTechName(data): Observable<any> {
    return this.http
      .put<any>(
        this.baseurl + "/customizedServices/updateOrder",
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  cancelOrder(id) {
    return this.http
      .put<any>(
        this.baseurl + "/customizedServices/" + id + "/cancel",
        "",
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  getOrderItems(id) {
    return this.http
      .get<any>(
        this.baseurl + "/customizedServices/" + id + "/items",
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  confirmAddedItems(data) {
    return this.http
      .put<any>(
        this.baseurl + "/customizedServices/confirmAddedItems",
        data,
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  // Error handling
  errorHandl(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
